import React from 'react';
import './ActionButtons.scss';

interface ActionButtonsProps {
  onSubmit: () => void;
  onCancel: () => void;
  buttonText: string;
  isSubmitting?: boolean;
  disableSubmit?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ onSubmit, onCancel, isSubmitting = false, buttonText, disableSubmit = false }) => {
  return (
    <div className='action-buttons-container'>
      <div className='buttons-wrapper'>
        <button analytics-id='cancel-button' className='cancel-button' onClick={onCancel} disabled={isSubmitting}>
          <span className='button-text'>Cancel</span>
        </button>
        <button analytics-id='add-task-button' className='add-task-button' onClick={onSubmit} disabled={isSubmitting || disableSubmit}>
          <span className='button-text'>{buttonText}</span>
        </button>
      </div>
    </div>
  );
};

export default ActionButtons;
